module.exports = __webpack_public_path__ + "img/logo.5f8fed82.png";